import BasicRouterView from "../../components/BasicRouterView.vue";

const terceirosRoutes = {
  path: "ter",
  redirect: { name: "cadastrarParceiros" },
  meta: {
    label: "Terceiros",
    icon: "how_to_reg",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "terceiro/cadastrar-parceiro",
      name: "cadastrarParceiros",
      meta: {
        label: "Cadastrar Parceiros",
        icon: "business",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./parceiro/views/CadastrarParceiro.vue"
        ),
    },
    {
      path: "terceiro/cadastrar-terceiro",
      name: "cadastrarTerceiros",
      meta: {
        label: "Cadastrar Terceiros",
        icon: "person",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./terceiro/views/CadastrarTerceiro.vue"
        ),
    },
  ],
};

export default terceirosRoutes;
